export default __webpack_public_path__ + "static/media/pizza-salami-pudelko.e64dd49d.png";